import GTM from 'general/js/gtm';

class GTMUserActions {
    trackJoinTheOneClubAction() {
        GTM.push('The One Club', 'Sign Up', 'Join the club');
    }

    trackTicketingAccountAction() {
        GTM.push('Ticketing', 'Sign Up', 'Join the club');
    }

    trackTicketingAccountActionClick() {
        GTM.push('Ticketing', 'Click', 'New Account');
    }

    trackVideoSignUpAction(eventLabel) {
        GTM.push('Video Sign Up', 'Sign Up', eventLabel);
    }

    trackVideoSignUpActionClick(eventLabel) {
        GTM.push('Video Sign Up', 'Click', eventLabel);
    }
}

export default new GTMUserActions();
